import React from 'react';
import ForgotPasswordTab from './ForgotPasswordTab';
import { Typography, Box } from '@mui/material';

const ForgotPassword = () => {
   return (
      <div>
         <Box
            sx={{ fontSize: { xs: '1.5rem', md: '2.3rem' },  marginX: { xs: 0, sm: 2 }  }}
            fontWeight={600}
            className="pageHeader font-cormorant"
            mb={2}
         >
            Forgot Password?
         </Box>
         <Typography
            sx={{ fontSize: { xs: '0.7rem', md: '1rem' },  marginX: { xs: 0, sm: 2 }  }}
            fontWeight={400}
            color="#58564d"
         >
            Enter your registered email or phone number and we’ll send you a
            link to verify your account.
         </Typography>
         <ForgotPasswordTab />
      </div>
   );
};

export default ForgotPassword;
